import { memo, useEffect, useRef, useState } from 'react';

const CHARS_PER_TICK = 3;
const TICK_MS = 16;

// Speech bubble for the character's own replies (as opposed to the user's plain
// right-aligned bubbles). `animate` should only be true for the most-recently-arrived
// message - replaying the typing effect for the whole history on every render would be
// wasted work and janky to look at, so callers gate this to the last item only.
function CharacterChatBubbleComponent({ text, animate }) {
  const [visibleCount, setVisibleCount] = useState(animate ? 0 : text.length);
  const frame = useRef(null);

  useEffect(() => {
    if (!animate) {
      setVisibleCount(text.length);
      return undefined;
    }
    setVisibleCount(0);
    let count = 0;
    function tick() {
      count = Math.min(text.length, count + CHARS_PER_TICK);
      setVisibleCount(count);
      if (count < text.length) {
        frame.current = setTimeout(tick, TICK_MS);
      }
    }
    frame.current = setTimeout(tick, TICK_MS);
    return () => clearTimeout(frame.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [text]);

  return (
    <div className="character-speech-bubble">
      <span className="character-speech-bubble-tail" aria-hidden="true" />
      {text.slice(0, visibleCount)}
    </div>
  );
}

export const CharacterChatBubble = memo(CharacterChatBubbleComponent);
